import { assignedScheduledDriver } from "../../../data/repository/scheduled.repository";

export const AssignScheduledUseCase = async (scheduled) => {
  try {
    const resp = await assignedScheduledDriver(scheduled);
    return resp.data;
  } catch (error) {
    return error.response.data;
  }
};
